export default __webpack_public_path__ + "static/media/footer_background.98f5a5db.svg";